<template>
    <v-card class="mx-auto" color="teal" dark max-width="400">
        <v-card-title>
            <v-list-item class="grow">
                <v-list-item-avatar color="white darken-3">
                    <Avatar />
                </v-list-item-avatar>

                <v-list-item-content align="left">
                    <v-list-item-title>Evan You</v-list-item-title>
                    <v-list-item-subtitle>Level 5: Puzzle Initiate</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-card-title>

        <v-card-text class="headline font-weight-bold">
            <div>Score: 213123</div>
        </v-card-text>
        <v-card-text class="font-weight-bold">
            <div>Days Played:</div>
            <div>Member Since:</div>
            <div>Puzzle League: Yes</div>
        </v-card-text>
    </v-card>
</template>

<script>
import Avatar from "./Avatar.vue";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
    name: "Leaderboard",
    props: ["userData"],
    components: { Avatar },
    data: () => {
        return {};
    },
    mounted() {},
    computed: {
        loading() {
            return !this.leaderboardData ? "#42bdbb" : false;
        },
    },
    watch: {
        linkedOnly: function (value) {
            console.log("on change linkedOnly " + value);
            this.$store.dispatch("setType", value ? "linked" : "all");
        },
        currentTab: function (tabIndex) {
            console.log("on change tab " + tabIndex);
            if (tabIndex === 0) {
                this.$store.dispatch("setNumDays", 7);
            } else if (tabIndex === 1) {
                this.$store.dispatch("setNumDays", 30);
            } else if (tabIndex === 2) {
                this.$store.dispatch("setNumDays", 999);
            }
        },
    },
    methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped></style>
